module.exports = __webpack_public_path__ + "img/tivoli-oriente.923a7e61.jpg";